import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/api";
import { useAuth } from "@/contexts/AuthContext";
import { analytics } from "@/services/analytics";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get("code");

    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/google/callback";
        const { data } = await api.post("/auth/session", {
          code,
          redirect_uri: redirectUri,
        });
        setUser(data);
        analytics.login("google");
        navigate("/", { replace: true });
      } catch (_e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser, searchParams]);

  return (
    <div className="min-h-screen grid place-items-center bg-[hsl(var(--zt-beige))]">
      <div className="text-center space-y-4">
        <Loader2 className="animate-spin text-[hsl(var(--zt-teal))] mx-auto" size={32} />
        <p className="font-heading uppercase tracking-[0.28em] text-[11px] text-[hsl(var(--zt-teal))]/70">
          Signing you in…
        </p>
      </div>
    </div>
  );
}
